export function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-amber-500/10 bg-[#0c0c0e]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <span className="w-9 h-9 border border-amber-400/70 rotate-45 flex items-center justify-center">
              <span className="-rotate-45 font-serif-lux font-semibold text-amber-400 text-lg leading-none">V</span>
            </span>
            <span className="leading-none">
              <span className="font-serif-lux text-lg text-zinc-100 block">Valet Premier</span>
              <span className="text-[8px] uppercase tracking-[0.45em] text-amber-400/90 block mt-1">Detailing</span>
            </span>
          </div>
          <p className="text-sm text-zinc-500 leading-relaxed">
            Concierge mobile automotive refinement. We bring the studio to your driveway.
          </p>
        </div>
        <div>
          <p className="text-xs uppercase tracking-[0.25em] text-amber-400/90 mb-4">Concierge Line</p>
          <p className="text-sm text-zinc-400">(681) 452-8599</p>
          <p className="text-sm text-zinc-400">Valetpremierdetailing@gmail.com</p>
          <p className="text-sm text-zinc-500 mt-2">Proudly serving Martinsburg and Berkeley, Jefferson, Washington &amp; Frederick Counties — 7 days a week</p>
        </div>
        <div>
          <p className="text-xs uppercase tracking-[0.25em] text-amber-400/90 mb-4">Hours</p>
          <p className="text-sm text-zinc-400">Mon – Sat: 8:00 AM – 6:00 PM</p>
          <p className="text-sm text-zinc-400">Sun: By appointment</p>
        </div>
      </div>
      <div className="border-t border-zinc-900 py-6 text-center text-xs text-zinc-600 tracking-widest uppercase">
        Valet Premier Detailing — Crafted in Obsidian &amp; Gold
      </div>
    </footer>
  );
}
